module.exports = __webpack_public_path__ + "static/img/logo2.54aa0ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2.png
// module id = xAza
// module chunks = 1